import { ChangeEventHandler, ReactNode, useMemo } from 'react';
import styles from './RadioToggleButton.module.css';
import EntryFilled from './svg/EntryFilled.svg';
import EntryUnfilled from './svg/EntryUnfilled.svg';

interface Props {
  children?: ReactNode;
  text?: string;
  subtext?: string;
  badgeText?: string;
  badgeStyle?: 'DEFAULT' | 'STYLE1';
  onChange?: ChangeEventHandler<HTMLInputElement>;
  selectedValue?: string;
  /** The group that this radio button belongs to. All components in the same
   * radioGroupName are part of the same input type=radio group. */
  radioGroupName: string;
  value: string;
  displayStyle?: 'TICKET';
}

const RadioToggleButton = (props: Props) => {
  // Ideally, this would use React's useId, however, it doesn't work in our
  // combination of NextJS and React versions
  const id = useMemo(() => {
    return 'RadioToggleButton_' + props.radioGroupName + '_' + props.value;
  }, [props.radioGroupName, props.value]);

  const isSelected = props.selectedValue === props.value;

  return (
    <div
      className={`${styles.container} ${isSelected ? styles.checked : ''} ${props.displayStyle === 'TICKET' ? styles.ticketDisplay : ''}`}
    >
      <input
        id={id}
        type="radio"
        name={props.radioGroupName}
        checked={isSelected}
        value={props.value}
        onChange={props.onChange}
      />
      {props.displayStyle === 'TICKET' ? (
        isSelected ? (
          <EntryFilled />
        ) : (
          <EntryUnfilled />
        )
      ) : null}
      <label htmlFor={id}>
        {props.text} {props.children}{' '}
        {props.subtext && (
          <span className={styles.subtext}>{props.subtext}</span>
        )}
        {props.badgeText && (
          <div
            className={
              styles.badge +
              ' ' +
              styles['badgeStyle_' + (props.badgeStyle || 'DEFAULT')]
            }
          >
            {props.badgeText}
          </div>
        )}
      </label>
    </div>
  );
};

export default RadioToggleButton;
